import { Fragment, useState, useRef } from 'react';
import { urlWithParams } from '../../../services/Util';
import styled from 'styled-components';
import { Link, useHistory } from 'react-router-dom';

export default function Convertkit({
	onClick,
	pageId,
	id: buttonId,
	label,
	feature,
	animate = 'wiggle',
	animateDuration,
	flagLabel,
	backgroundColor,
	textColor,
	APIKey,
	listId,
	valueIsSet = false,
	welcomeMessage,
	successMessage,
}) {
	const [isSubscribed, setIsSubscribed] = useState(false);
	const [email, setEmail] = useState('');

	const emailInput = useRef();

	const { __ } = wp.i18n;
	const history = useHistory();

	if (
		(!label || !label.length || !APIKey || !APIKey.length || !listId || !listId.length) &&
		!valueIsSet
	) {
		return false;
	}

	function onEmailUpdate(e) {
		setEmail(e.target.value);
	}

	function doSubscribe(e) {
		const { current: emailCurrent } = emailInput;

		if (!email.length) {
			emailCurrent.focus();
			return false;
		}

		window.jQuery
			.post(window.social_link_pages.admin_ajax, {
				action: 'social_link_pages_Convertkit_subscribe',
				email: email,
				page_id: pageId,
				button_id: buttonId,
				_wpnonce: document.getElementById('social_link_pages_wpnonce').value,
			})
			.always((response) => {
				setIsSubscribed(true);

				setTimeout(() => {
					history.push(urlWithParams({ m: '' }));
				}, 4000);
			});
	}

	return (
		<Fragment>
			<p className="container slp-Section slp-Convertkit">
				<StyledButton
					to={urlWithParams({ m: 'convertkit' })}
					className={`btn btn-block ${'animate' === feature ? animate : ''} ${
						'animate' === feature && 'forever' === animateDuration ? 'forever' : ''
					}`}
					backgroundcolor={backgroundColor}
					textcolor={textColor}
				>
					{label}
					{'flag' === feature && (
						<StyledFlag>
							{!flagLabel || '' === flagLabel ? (
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path d="M12 .288l2.833 8.718H24l-7.417 5.389 2.833 8.718L12 17.725l-7.417 5.388 2.833-8.718L0 9.006h9.167z" />
								</svg>
							) : (
								<i>{flagLabel}</i>
							)}
						</StyledFlag>
					)}
				</StyledButton>
			</p>
		</Fragment>
	);
}

const StyledButton = styled(Link)`
	${(props) =>
		'' !== props.backgroundcolor ? `background: rgb(${props.backgroundcolor}) !important;` : ''}
	${(props) => ('' !== props.textcolor ? `color: rgb(${props.textcolor}) !important;` : '')}
	position: relative;
`;

const StyledFlag = styled.span`
	position: absolute;
	right: -0.618rem;
	top: -0.618rem;
	transform: rotate(8deg);

	i {
		background: gold;
		border-radius: 0.382rem;
		color: black;
		font-size: 0.82rem;
		padding: 0.236rem 0.618rem;
	}

	svg {
		fill: gold !important;
		margin-right: 0.5rem;
		margin-top: -0.5rem;
	}
`;
